/**
 * BackOffice Auth API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {
  HttpClient,
  HttpContext,
  HttpEvent,
  HttpHeaders,
  HttpParams,
  HttpResponse,
} from "@angular/common/http";
import { Inject, Injectable, Optional } from "@angular/core";

import { Observable } from "rxjs";

import { BaseService } from "../api.base.service";
import { Configuration } from "../configuration";
// @ts-ignore
import { Auth2faSendPostRequest } from "../model/auth2faSendPostRequest";
// @ts-ignore
import { Auth2faVerifyPostRequest } from "../model/auth2faVerifyPostRequest";
// @ts-ignore
import { AuthImpersonatePostRequest } from "../model/authImpersonatePostRequest";
// @ts-ignore
import { AuthLoginPost200Response } from "../model/authLoginPost200Response";
// @ts-ignore
import { AuthLogoutPostRequest } from "../model/authLogoutPostRequest";
// @ts-ignore
import { AuthRefreshPostRequest } from "../model/authRefreshPostRequest";
// @ts-ignore
import { CurrentUser } from "../model/currentUser";
// @ts-ignore
import { LoginRequest } from "../model/loginRequest";
// @ts-ignore
import { TokenResponse } from "../model/tokenResponse";
import { OpenApiHttpParams, QueryParamStyle } from "../query.params";
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from "../variables";

@Injectable({
  providedIn: "root",
})
export class AuthApi extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration
  ) {
    super(basePath, configuration);
  }

  /**
   * Send the 2FA code to the pending user
   * Uses the MFA token from /auth/login to identify the pending user and emails a code.
   * @endpoint post /auth/2fa/send
   * @param auth2faSendPostRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public auth2faSendPost(
    auth2faSendPostRequest: Auth2faSendPostRequest,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any>;
  public auth2faSendPost(
    auth2faSendPostRequest: Auth2faSendPostRequest,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<any>>;
  public auth2faSendPost(
    auth2faSendPostRequest: Auth2faSendPostRequest,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<any>>;
  public auth2faSendPost(
    auth2faSendPostRequest: Auth2faSendPostRequest,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (
      auth2faSendPostRequest === null ||
      auth2faSendPostRequest === undefined
    ) {
      throw new Error(
        "Required parameter auth2faSendPostRequest was null or undefined when calling auth2faSendPost."
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(["application/json"]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Accept",
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ["application/json"];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Content-Type",
        httpContentTypeSelected
      );
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    const localVarPath = `/auth/2fa/send`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>("post", `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: auth2faSendPostRequest,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined
        ? { transferCache: localVarTransferCache }
        : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Verify the 2FA code and issue tokens
   * @endpoint post /auth/2fa/verify
   * @param auth2faVerifyPostRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public auth2faVerifyPost(
    auth2faVerifyPostRequest: Auth2faVerifyPostRequest,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TokenResponse>;
  public auth2faVerifyPost(
    auth2faVerifyPostRequest: Auth2faVerifyPostRequest,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TokenResponse>>;
  public auth2faVerifyPost(
    auth2faVerifyPostRequest: Auth2faVerifyPostRequest,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TokenResponse>>;
  public auth2faVerifyPost(
    auth2faVerifyPostRequest: Auth2faVerifyPostRequest,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (
      auth2faVerifyPostRequest === null ||
      auth2faVerifyPostRequest === undefined
    ) {
      throw new Error(
        "Required parameter auth2faVerifyPostRequest was null or undefined when calling auth2faVerifyPost."
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(["application/json"]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Accept",
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ["application/json"];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Content-Type",
        httpContentTypeSelected
      );
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    const localVarPath = `/auth/2fa/verify`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<TokenResponse>(
      "post",
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: auth2faVerifyPostRequest,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Log in as a client (Client portal only)
   * Client portal only. Requires employee/admin credentials; issues an access token for the impersonated client carrying impersonator claims.
   * @endpoint post /auth/impersonate
   * @param authImpersonatePostRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public authImpersonatePost(
    authImpersonatePostRequest: AuthImpersonatePostRequest,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TokenResponse>;
  public authImpersonatePost(
    authImpersonatePostRequest: AuthImpersonatePostRequest,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TokenResponse>>;
  public authImpersonatePost(
    authImpersonatePostRequest: AuthImpersonatePostRequest,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TokenResponse>>;
  public authImpersonatePost(
    authImpersonatePostRequest: AuthImpersonatePostRequest,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (
      authImpersonatePostRequest === null ||
      authImpersonatePostRequest === undefined
    ) {
      throw new Error(
        "Required parameter authImpersonatePostRequest was null or undefined when calling authImpersonatePost."
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(["application/json"]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Accept",
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ["application/json"];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Content-Type",
        httpContentTypeSelected
      );
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    const localVarPath = `/auth/impersonate`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<TokenResponse>(
      "post",
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: authImpersonatePostRequest,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Authenticate with username + password
   * On success returns access + refresh tokens. If the user has 2FA enabled, returns &#x60;mfaRequired&#x60; with a short-lived MFA token instead of session tokens (no code sent yet; call /auth/2fa/send).
   * @endpoint post /auth/login
   * @param loginRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public authLoginPost(
    loginRequest: LoginRequest,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<AuthLoginPost200Response>;
  public authLoginPost(
    loginRequest: LoginRequest,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<AuthLoginPost200Response>>;
  public authLoginPost(
    loginRequest: LoginRequest,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<AuthLoginPost200Response>>;
  public authLoginPost(
    loginRequest: LoginRequest,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (loginRequest === null || loginRequest === undefined) {
      throw new Error(
        "Required parameter loginRequest was null or undefined when calling authLoginPost."
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(["application/json"]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Accept",
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ["application/json"];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Content-Type",
        httpContentTypeSelected
      );
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    const localVarPath = `/auth/login`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<AuthLoginPost200Response>(
      "post",
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: loginRequest,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Revoke the caller\&#39;s refresh token(s)
   * @endpoint post /auth/logout
   * @param authLogoutPostRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public authLogoutPost(
    authLogoutPostRequest?: AuthLogoutPostRequest,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any>;
  public authLogoutPost(
    authLogoutPostRequest?: AuthLogoutPostRequest,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<any>>;
  public authLogoutPost(
    authLogoutPostRequest?: AuthLogoutPostRequest,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<any>>;
  public authLogoutPost(
    authLogoutPostRequest?: AuthLogoutPostRequest,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    // authentication (bearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      "bearerAuth",
      "Authorization",
      localVarHeaders,
      "Bearer "
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(["application/json"]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Accept",
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ["application/json"];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Content-Type",
        httpContentTypeSelected
      );
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    const localVarPath = `/auth/logout`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<any>("post", `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: authLogoutPostRequest,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      ...(localVarTransferCache !== undefined
        ? { transferCache: localVarTransferCache }
        : {}),
      reportProgress: reportProgress,
    });
  }

  /**
   * Current authenticated user (identity, roles, rights, impersonation state)
   * @endpoint get /auth/me
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public authMeGet(
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<CurrentUser>;
  public authMeGet(
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<CurrentUser>>;
  public authMeGet(
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<CurrentUser>>;
  public authMeGet(
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    // authentication (bearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      "bearerAuth",
      "Authorization",
      localVarHeaders,
      "Bearer "
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(["application/json"]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Accept",
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    const localVarPath = `/auth/me`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<CurrentUser>(
      "get",
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Exchange a refresh token for a new token pair (rotates the refresh token)
   * @endpoint post /auth/refresh
   * @param authRefreshPostRequest
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public authRefreshPost(
    authRefreshPostRequest: AuthRefreshPostRequest,
    observe?: "body",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TokenResponse>;
  public authRefreshPost(
    authRefreshPostRequest: AuthRefreshPostRequest,
    observe?: "response",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TokenResponse>>;
  public authRefreshPost(
    authRefreshPostRequest: AuthRefreshPostRequest,
    observe?: "events",
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TokenResponse>>;
  public authRefreshPost(
    authRefreshPostRequest: AuthRefreshPostRequest,
    observe: any = "body",
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: "application/json";
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    if (
      authRefreshPostRequest === null ||
      authRefreshPostRequest === undefined
    ) {
      throw new Error(
        "Required parameter authRefreshPostRequest was null or undefined when calling authRefreshPost."
      );
    }

    let localVarHeaders = this.defaultHeaders;

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ??
      this.configuration.selectHeaderAccept(["application/json"]);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Accept",
        localVarHttpHeaderAcceptSelected
      );
    }

    const localVarHttpContext: HttpContext =
      options?.context ?? new HttpContext();

    const localVarTransferCache: boolean = options?.transferCache ?? true;

    // to determine the Content-Type header
    const consumes: string[] = ["application/json"];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set(
        "Content-Type",
        httpContentTypeSelected
      );
    }

    let responseType_: "text" | "json" | "blob" = "json";
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith("text")) {
        responseType_ = "text";
      } else if (
        this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)
      ) {
        responseType_ = "json";
      } else {
        responseType_ = "blob";
      }
    }

    const localVarPath = `/auth/refresh`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<TokenResponse>(
      "post",
      `${basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: authRefreshPostRequest,
        responseType: <any>responseType_,
        ...(withCredentials ? { withCredentials } : {}),
        headers: localVarHeaders,
        observe: observe,
        ...(localVarTransferCache !== undefined
          ? { transferCache: localVarTransferCache }
          : {}),
        reportProgress: reportProgress,
      }
    );
  }
}
